import React from "react";
import { motion } from "framer-motion";

/**
 * Reveal — wraps children with a subtle fade + rise on scroll-in.
 * Designed for editorial, luxury cadence (slow & deliberate).
 */
const Reveal = ({
    children,
    delay = 0,
    y = 28,
    duration = 0.9,
    once = true,
    className = "",
    as: Tag = "div",
}) => {
    const MotionTag = motion[Tag] || motion.div;
    return (
        <MotionTag
            initial={{ opacity: 0, y }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once, amount: 0.25 }}
            transition={{
                duration,
                delay,
                ease: [0.22, 1, 0.36, 1],
            }}
            className={className}
        >
            {children}
        </MotionTag>
    );
};

export default Reveal;
